import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Config {
  apiUrl: string = 'api';
}
